// extracted by mini-css-extract-plugin
export var gif = "_ma-0";